<div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''" class="confirmation-dialog-container">
  <div *ngIf="data.icon.includes('request-send')">
    <span class="icon-close-classroom-modal d-block cursor-pointer ml-auto" (click)="onCancel(data.cancelTrackEvent, data.trackPage)">
      <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
    </span>
  </div>
  <div class="text-center">
    <img src="{{ data.icon }}" alt="delete-icon" *ngIf="data.title !== 'Welcome'" />
    <img
      src="{{ data.icon }}"
      alt="delete-icon"
      *ngIf="data.title === 'Welcome'"
      [ngClass]="{
        'send-request-img': data.icon.includes('request-send')
      }"
      height="100"
      width="100"
    /><br />

    <label class="confirmation main-title mt-2 quicksand-bold-label"> {{ data.accessCodeLabel }}</label>
    <br />
    <label class="confirmation sub-title quicksand-bold-label mt-2" *ngIf="data.confirmationMessage">
      {{ data.confirmationMessage }}
    </label>
    <label class="confirmation sub-title quicksand-bold-label mt-2" *ngIf="data.description">{{ data.description }} </label>
  </div>
  <div class="d-flex w-100 mt-3">
    <button
      nbButton
      class="delete-lesson-plan bg-white bg-white-color m-2 w-100 quicksand-bold-label text-capitalize cancel"
      (click)="onCancel(data.cancelTrackEvent, data.trackPage)"
      *ngIf="data.title !== 'Welcome'"
    >
      {{ data.cancelButtonText }}
    </button>
    <button
      nbButton
      color="warn"
      class="confirm m-2 w-100 quicksand-bold-label text-capitalize"
      (click)="onConfirm(data.confirmTrackEvent, data.trackPage)"
      [ngClass]="
        data.confirmButtonText === 'Confirm' ||
        data.confirmButtonText === 'Yes' ||
        data.confirmButtonText.includes('Yes') ||
        data.confirmButtonText.includes('Save')||
        data.confirmButtonText === 'Proceed'
          ? 'confirm'
          : data.confirmButtonText.includes('Pause')
          ? 'start-assessment'
          : 'delete'
      "
      *ngIf="data.title !== 'Welcome'"
    >
      {{ data.confirmButtonText }}
    </button>

    <button
      nbButton
      class="ok m-auto quicksand-bold-label text-capitalize"
      (click)="onConfirm(data.confirmTrackEvent, data.trackPage)"
      *ngIf="data.title === 'Welcome' && !data.icon.includes('request-send')"
      [ngClass]="data.confirmButtonText === 'Start' || data.confirmButtonText === 'Reactivate' ? 'start-assessment' : ''"
    >
      {{ data.confirmButtonText }}
    </button>

    
  </div>
</div>
